import { HttpService } from '@/shared/services'
import { ReceiptTemplate } from '../models/ReceiptTemplate'

const http = new HttpService()

export const getReceiptTemplates = async () => {
  const response = await http.get<ReceiptTemplate[]>('receiptTemplates')
  return response.data
}
